<nb-card class="bg-transparent">
  <nb-card-header class="pb-0 nb-card-header">
    <div class="row">
      <div class="col-lg-4 col-12 text-start">
        <h4 class="fw-semibold ls-1">Warehouse List</h4>
      </div>
      <div class="col-lg-8 col-12">
        <div class="d-flex justify-content-end">
          <button (click)="addWarehouseClicked()" mat-raised-button class="new-compact-btn" color="primary">
            <span class="fa-icon-wrapper"><i class="fas fa-plus me-2"></i></span>
            New Warehouse
          </button>
        </div>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body class="bg-transparent">
    <nb-card class="editForm bg-transparent" [class.active]="editActive" style="overflow: hidden;">
      <nb-card-header>
        <div class="row">
          <div class="col">
            <h2 *ngIf="editWarehouse.id === undefined">Create Warehouse</h2>
            <h2 *ngIf="editWarehouse.id !== undefined">Edit Warehouse for {{editWarehouse.name}}</h2>
          </div>
          <div class="col" style="text-align: right; color: crimson;" *ngIf="warehouseId !== 0">
            <button mat-icon-button (click)="deleteWarehouseClicked(WarehouseForm);" [disabled]="!editWarehouse.id"><i
                class="fas fa-trash-alt fa-2x"></i></button>
          </div>
        </div>
      </nb-card-header>
      <nb-card-body>
        <form #WarehouseForm="ngForm" id="WarehouseForm" name="WarehouseForm" style="margin-top: 15px;">

          <div class="form-group col-12">
            <h3>Details</h3>
            <div class="container">
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <mat-form-field>
                      <input type="text" matInput id="name" name="name" [(ngModel)]="editWarehouse.name"
                        placeholder='Name' [disabled]="!!isREPToken && !!editWarehouse?.id" [value]="editWarehouse?.name" required #name="ngModel">
                    </mat-form-field>
                    <div class="row" [hidden]="name.valid || name.pristine" class="alert alert-danger">Name is
                      required</div>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <mat-form-field>
                      <input type="text" matInput id="warehouseDescription" name="warehouseDescription"
                        [(ngModel)]="editWarehouse.description" placeholder='Description'
                        [value]="editWarehouse?.description" required #name="ngModel">
                    </mat-form-field>
                    <div class="row" [hidden]="name.valid || name.pristine" class="alert alert-danger">Descrption is
                      required</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <mat-form-field>
                      <input type="number" matInput id="warehouseLatatude" name="warehouseLatatude"
                        [(ngModel)]="editWarehouse.latitude" placeholder='Latitude' [value]="editWarehouse?.latitude"
                        #name="ngModel">
                    </mat-form-field>
                    <div class="row" [hidden]="name.valid || name.pristine" class="alert alert-danger">Latitude is
                      required</div>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <mat-form-field>
                      <input type="number" matInput id="warehouseLongitude" name="warehouseLongitude"
                        [(ngModel)]="editWarehouse.longitude" placeholder='Longitude' [value]="editWarehouse?.longitude"
                        #name="ngModel">
                    </mat-form-field>
                    <div class="row" [hidden]="name.valid || name.pristine" class="alert alert-danger">Longitude is
                      required</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <mat-form-field>
                      <input type="text" matInput id="integrationId" name="integrationId"
                        [(ngModel)]="editWarehouse.integrationId" placeholder='Integration Id' [value]="editWarehouse?.integrationId"
                        #name="ngModel">
                    </mat-form-field>
                    <div class="row" [hidden]="name.valid || name.pristine" class="alert alert-danger">Integration Id is
                      required</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="form-group">
                    <mat-form-field>
                      <input type="text" matInput id="famousAccessGroup" name="famousAccessGroup"
                        [(ngModel)]="editWarehouse.famousAccessGroup" placeholder='Access Group' [value]="editWarehouse?.famousAccessGroup"
                        #name="ngModel">
                    </mat-form-field>
                    <div class="row" [hidden]="name.valid || name.pristine" class="alert alert-danger">Access Group is
                      required</div>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="form-group">
                    <mat-form-field>
                      <input type="text" matInput id="barcode" name="barcode"
                        [(ngModel)]="editWarehouse.barcode" placeholder='Barcode' [value]="editWarehouse?.barcode"
                        #name="ngModel">
                    </mat-form-field>
                    <div class="row" [hidden]="name.valid || name.pristine" class="alert alert-danger">Barcode is
                      required</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <mat-checkbox placeholder="Active?" name="isActive" id="isActive" [(ngModel)]="editWarehouse.isActive"
                    [(value)]="editWarehouse.isActive" #active="ngModel" color="primary">Active?</mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </form>
      </nb-card-body>
      <nb-card-footer class="row" style="margin-top: 10px;">
        <div [nbSpinner]="submitting" class="col-md-auto d-flex align-items-center">
          <button *ngIf="!submitting" type="submit" form="WarehouseForm" mat-raised-button class="btn-save-change"
            (click)="saveWarehouseClicked(WarehouseForm);">Save</button>


            <button mat-button (click)="cancelClicked(WarehouseForm);" class="btn-gap ">
              Cancel
            </button>
        </div>
      </nb-card-footer>
    </nb-card>

    <div class="grid-wrapper">
      <div class="mat-elevation-z2 table-scroll" [nbSpinner]="warehouseLoading">
        <table mat-table class="full-width-table" [dataSource]="dataSource.data" matSort aria-label="Elements">
          <!-- Id Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Id</th>
            <td mat-cell *matCellDef="let row">{{row.id}}</td>
          </ng-container>
  
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Warehouse</th>
            <td mat-cell *matCellDef="let row">{{row.name}}</td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Warehouse Description</th>
            <td mat-cell *matCellDef="let row">{{row.description}}</td>
          </ng-container>
          <ng-container matColumnDef="integrationId">
            <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Integration Id</th>
            <td mat-cell *matCellDef="let row">{{row.integrationId}}</td>
          </ng-container>
  
  
          <ng-container matColumnDef="barcode">
            <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Barcode</th>
            <td mat-cell *matCellDef="let row">{{row.barcode}}</td>
          </ng-container>
  
          <ng-container matColumnDef="famousAccessGroup">
            <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Access Group</th>
            <td mat-cell *matCellDef="let row">{{row.famousAccessGroup}}</td>
          </ng-container>
          <ng-container matColumnDef="isActive">
            <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Is Active</th>
            <td mat-cell *matCellDef="let row">
              <div *ngIf="row.isActive === true" style="color: green;">
                <fa-icon [icon]="faCheck"></fa-icon>
              </div>
              <div *ngIf="row.isActive === false" style="color: darkRed">
                <fa-icon [icon]="faTimes"></fa-icon>
              </div>
            </td>
          </ng-container>
  
          <!-- Edit Column -->
          <ng-container matColumnDef="edit">
            <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
            <td mat-cell *matCellDef="let row"><button mat-icon-button (click)="editClicked(row.id);"><i
                  class="fas fa-edit fa-lg"></i></button></td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="50"
          [pageSizeOptions]="[25, 50, 100, 250]">
        </mat-paginator>
      </div>
    </div>
  </nb-card-body>
</nb-card>